import React from 'react';
import './Footer.css';
import CallIcon from '../assets/Call.svg';
import LocationIcon from '../assets/Location.svg';
import MessageIcon from '../assets/Message.svg';
import FacebookIcon from '../assets/akar-icons_facebook-fill.png';
import LinkedInIcon from '../assets/akar-icons_linkedin-box-fill.png';
import TwitterIcon from '../assets/akar-icons_twitter-fill.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img
            src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/LogoWhite.png"
            alt="Ben Nasr Logo"
          />
        </div>

        <div className="footer-divider"></div>

        <div className="footer-sections">
          <div className="footer-links">
            <a href="/">Acceuil</a>
            <a href="/le-cabinet">Le Cabinet</a>
            <a href="/nos-avocats">Nos Avocats</a>
            <a href="/domaines-intervention">Domaines d'Intervention</a>
            <a href="/contact">Contact</a>
          </div>

          <div className="footer-contact">
            <h3>Contact</h3>
            <div className="contact-item">
              <img src={CallIcon} alt="Phone" className="contact-icon" />
              <span>+216 71 785 257</span>
            </div>
            <div className="contact-item">
              <img src={LocationIcon} alt="Location" className="contact-icon" />
              <span>17 Rue Hassen Ibn Noomen, Tunis Tunisia 1002</span>
            </div>
            <div className="contact-item">
              <img src={MessageIcon} alt="Email" className="contact-icon" />
              <span>Contact@cabinetbennasr.com</span>
            </div>
          </div>

          <div className="footer-social">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <img src={FacebookIcon} alt="Facebook" className="social-icon" />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <img src={LinkedInIcon} alt="LinkedIn" className="social-icon" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <img src={TwitterIcon} alt="Twitter" className="social-icon" />
            </a>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-copyright">
          <p>Copyright @2026 Cabinet Ben Nasr All Right Reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
